// local
import Api from '.';

export function list() {
    return Api.get('/device');
}

export function create(data) {
    return Api.post('/device', data);
}

export function update(id, data) {
    return Api.put(`/device/${id}`, data);
}

export default { list, create, update };
